let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a3bTr")).then(() => parcelRequire('3GVQ5'));